import { useMemo } from 'react';

import { SettingsIcon as GearIcon, ArrowUpDownIcon as SortIcon } from '@air/design-icons';
import { type DropdownMenuOption } from '@air/primitive-dropdown-menu';
import { useAirModal } from '@air/provider-modal';

import { GeneralLibrarySettingsModal } from '~/components/LibraryBeta/GeneralLibrarySettingsModal/GeneralLibrarySettingsModal';
import { useSortMenuOptions } from '~/components/LibraryBeta/hooks/useSortMenuOptions';

export const useGeneralLibraryMenuOptions = () => {
  const [showGeneralLibrarySettingsModal] = useAirModal(GeneralLibrarySettingsModal);
  const { sortDropdownMenuOptions } = useSortMenuOptions({ location: 'general library' });

  const menuOptions = useMemo(() => {
    const options: DropdownMenuOption[] = [
      {
        id: 'library-settings',
        label: 'Library settings',
        onSelect: () => showGeneralLibrarySettingsModal(),
        prefix: <GearIcon size="sm" />,
        type: 'item',
      },
    ];

    if (sortDropdownMenuOptions.length > 0) {
      options.push({
        id: 'sort-boards',
        label: 'Sort boards',
        prefix: <SortIcon size="sm" />,
        type: 'sub',
        options: sortDropdownMenuOptions,
      });
    }

    return options;
  }, [showGeneralLibrarySettingsModal, sortDropdownMenuOptions]);

  return { menuOptions };
};
